import { render, staticRenderFns } from "./ChildSafetyPolicy.vue?vue&type=template&id=6fe01f0e&scoped=true"
import script from "./ChildSafetyPolicy.vue?vue&type=script&lang=js"
export * from "./ChildSafetyPolicy.vue?vue&type=script&lang=js"
import style0 from "./ChildSafetyPolicy.vue?vue&type=style&index=0&id=6fe01f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe01f0e",
  null
  
)

export default component.exports